module.exports = __webpack_public_path__ + "img/mechanic.224ec7c3.webp";